import React from 'react';
import _ from 'lodash';

export const useWindowResizeEffect = (
  callback: any,
  { delay = 200, id = 'root' }
) => {
  // use toggle state as an event trigger
  const [fireEvent, setFireEvent] = React.useState(false);

  // get DOM element width
  // root element will be used if no element id is provided
  const element = React.useMemo(() => document.getElementById(id) || {}, [id]);
  // @ts-expect-error TS(2339): Property 'offsetWidth' does not exist on type '{}'... Remove this comment to see the full error message
  const width = element.offsetWidth || window.innerWidth;

  // fire event when DOM element is located
  React.useEffect(() => setFireEvent((prev) => !prev), [element]);

  // fire event on window resize
  window.onresize = _.debounce(() => setFireEvent((prev) => !prev), delay);

  // memoize callback into returnable value
  const result = React.useMemo(
    () => callback(width),
    // eslint-disable-next-line
    [fireEvent]
  );

  // clear window resize event on component unmount
  React.useEffect(() => {
    return () => (window.onresize = null);
  }, []);

  return result;
};
